import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon.jsx';

export default class ResultsList extends Component {
    static propTypes = {
        defaultResults: PropTypes.array,
        onDelete: PropTypes.func
    };

    static defaultProps = {
        defaultResults: [],
        onDelete: null
    };

    constructor(props) {
        super(props);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    shouldComponentUpdate() {
        return true;
    }

    handleDeleteClick(option) {
        if (this.props.onDelete) {
            this.props.onDelete(option)
        }
    }

    render() {
        return (
            <div className="listView">
                <ul className="listView__listGroup">
                    {this.props.defaultResults.map((option) => (
                        <li
                            className="listView__option"
                            key={option}
                        >
                            <label className="listView__label">{option}</label>
                            <span onClick={() => this.handleDeleteClick(option)}>
                                <Icon
                                    className={'listView__imgContainer'}
                                    name="delete"
                                />
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ResultsList.jsx